import { toShortDate } from "@api/date";
import { CreatedBy } from "@components/backoffice/ChangedBy";
import { DetailsHeader } from "@components/backoffice/DetailsHeader";
import { RestrictedAccessLabel } from "@components/backoffice/RestrictedAccessLabel";
import { CopyButton } from "@components/CopyButton";
import { DateTime } from "luxon";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Header, Icon, Label } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { FrontSiteRoutes } from "@routes/urls";

export class SpecialCollectionHeader extends Component {
  formatType = (type) => {
    if (!type) {
      return "Theses and Dissertations";
    }

    // Define a mapping for specific collection types
    const typeMapping = {
      "MASTER'S_THESIS": "Master's Thesis",
    };

    if (type in typeMapping) {
      return typeMapping[type];
    }

    // Default formatting for other types
    return type
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
  };

  formatAuthors = (authors) => {
    if (!authors || authors.length === 0) {
      return null;
    }

    // If authors is an array of objects with full_name
    if (Array.isArray(authors)) {
      return authors
        .map((author) => {
          if (typeof author === "object") {
            // Handle both full_name (API response) and fullName (frontend format)
            return author.full_name || author.fullName || "";
          }
          return author;
        })
        .filter((name) => name) // Remove empty strings
        .join(", ");
    }

    // If authors is a string
    if (typeof authors === "string") {
      return authors;
    }

    return null;
  };

  render() {
    const { data } = this.props;

    if (!data || !data.metadata) {
      return null;
    }

    const recordInfo = (
      <>
        <label className="muted">Theses and Dissertaions</label>{" "}
        {data.metadata.pid || data.pid}{" "}
        <CopyButton text={data.metadata.pid || data.pid} />
        {data.metadata.created_by && (
          <>
            <br />
            <label className="muted">Created by</label>{" "}
            <CreatedBy metadata={data.metadata} />
          </>
        )}
        <br />
        <label className="muted">Created on</label>{" "}
        {data.created ? toShortDate(DateTime.fromISO(data.created)) : "N/A"}
        <br />
        <RestrictedAccessLabel
          isRestricted={data.metadata.restricted || false}
        />
        <Label
          as={Link}
          to={FrontSiteRoutes.specialCollectionDetailsFor(data.metadata.pid)}
          color="grey"
        >
          <Icon name="linkify" />
          View in Frontsite
        </Label>
      </>
    );

    const formattedAuthors = this.formatAuthors(data.metadata.authors);

    return (
      <DetailsHeader
        title={
          <>
            <Header.Subheader className="bo-details-subheader">
              {this.formatType(data.metadata.collection_type)}
            </Header.Subheader>
            {data.metadata.title || "Untitled Collection"}
          </>
        }
        subTitle={
          formattedAuthors && <span className="muted">{formattedAuthors}</span>
        }
        pid={data.metadata.pid || data.pid}
        image={
          <Icon
            name="file text"
            size="huge"
            color="black"
            className="special-collection-icon"
          />
        }
        recordInfo={recordInfo}
      >
        {/* Department/Curator info */}
        {(data.metadata.department || data.metadata.curator) && (
          <div className="pt-default">
            {data.metadata.department && (
              <Label color="grey" size="small">
                <Icon name="building" />
                {data.metadata.department}
              </Label>
            )}
            {data.metadata.curator && (
              <Label color="grey" size="small">
                <Icon name="user" />
                {data.metadata.curator}
              </Label>
            )}
          </div>
        )}
      </DetailsHeader>
    );
  }
}

SpecialCollectionHeader.propTypes = {
  data: PropTypes.object.isRequired,
};
